// The stored country is a French name ("Pays-Bas"), not a code: it is what the
// address Pays select writes and what the backend persists.
export const ADDRESS_COUNTRIES = [
    { value: "France", labelKey: "france", aliases: ["FR"] },
    { value: "Belgique", labelKey: "belgium" },
    { value: "Suisse", labelKey: "switzerland" },
    { value: "Luxembourg", labelKey: "luxembourg" },
    { value: "Allemagne", labelKey: "germany" },
    { value: "Espagne", labelKey: "spain" },
    { value: "Italie", labelKey: "italy" },
    { value: "Royaume-Uni", labelKey: "uk" },
    { value: "Pays-Bas", labelKey: "netherlands", aliases: ["NL", "Netherlands"] },
    { value: "Canada", labelKey: "canada", aliases: ["CA"] },
];
export function countryLabelKey(labelKey) {
    return `organisation.detail.options.country.${labelKey}`;
}
export const STORED_COUNTRY_NAMES = {
    label: (country) => country,
    canonical: (text) => text.trim(),
};
const same = (a, b) => a.trim().toLowerCase() === b.trim().toLowerCase();
export function isKnownAddressCountry(text) {
    return ADDRESS_COUNTRIES.some((c) => same(c.value, text) || (c.aliases ?? []).some((alias) => same(alias, text)));
}
export function countryNames(t) {
    const find = (text) => ADDRESS_COUNTRIES.find((c) => same(c.value, text) || (c.aliases ?? []).some((alias) => same(alias, text)));
    return {
        label(country) {
            const entry = find(country);
            return entry ? t(countryLabelKey(entry.labelKey)) : country;
        },
        canonical(text) {
            const entry = find(text) ?? ADDRESS_COUNTRIES.find((c) => same(t(countryLabelKey(c.labelKey)), text));
            return entry ? entry.value : text.trim();
        },
    };
}
